/// <amd-module name="TFS/Admin/Views/Teams/redux/TeamsRootProviderProps" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IRootProviderProps } from "VSS/Redux/RootProvider";

export interface ITeamsHubSagaContext {
    pageContext: IVssPageContext;
}

export function getTeamsHubRootProviderProps(pageContext: IVssPageContext): IRootProviderProps<ITeamsHubSagaContext, any> {
    const initialState = {};

    const sagaContext = { pageContext };

    return {
        initialState,
        sagaContext,
        scenarioName: "TeamsHub",
        modules: []
    };
}
